const AgentsFactoryActionTypes = {
  AGENTS_FACTORY_SIGNUP_REQUEST: 'AGENTS_FACTORY_SIGNUP_REQUEST',
  AGENTS_FACTORY_SIGNUP_SUCCESS: 'AGENTS_FACTORY_SIGNUP_SUCCESS',
  AGENTS_FACTORY_SIGNUP_FAILURE: 'AGENTS_FACTORY_SIGNUP_FAILURE',
  AGENTS_FACTORY_CREATE_REQUEST: 'AGENTS_FACTORY_CREATE_REQUEST',
  AGENTS_FACTORY_CREATE_SUCCESS: 'AGENTS_FACTORY_CREATE_SUCCESS',
  AGENTS_FACTORY_CREATE_FAILURE: 'AGENTS_FACTORY_CREATE_FAILURE',
  AGENTS_FACTORY_CHANGE_STATUS_REQUEST: 'AGENTS_FACTORY_CHANGE_STATUS_REQUEST',
  AGENTS_FACTORY_CHANGE_STATUS_SUCCESS: 'AGENTS_FACTORY_CHANGE_STATUS_SUCCESS',
  AGENTS_FACTORY_CHANGE_STATUS_FAILURE: 'AGENTS_FACTORY_CHANGE_STATUS_FAILURE',
};

export { AgentsFactoryActionTypes };
